{
  "wakeEvent": "startup.check",
  "statuses": { "ready": "Ready", "migrating": "Migrating", "failed": "Failed" },
  "phases": { "checking": "Checking", "migrating": "Migrating", "verifying": "Verifying", "post_migration": "PostMigration" },
  "errors": { "migration_error": "MigrationError", "critical_error": "CriticalError", "database_unavailable": "DatabaseUnavailable", "schema_mismatch": "SchemaMismatch", "pending_migrations": "PendingMigrations" }
}
